import { z } from 'zod';
// =============================================================================
// AI Usage
// =============================================================================
export const AiUsageSummarySchema = z.object({
    sttSecondsUsed: z.number(),
    sttSecondsLimit: z.number(),
    llmWeightedTokensUsed: z.number(),
    llmWeightedTokensLimit: z.number(),
    periodStart: z.string(),
    periodEnd: z.string(),
});
export const AiUsageResponseSchema = AiUsageSummarySchema;
// Super Admin - cross-account AI usage
export const SuperAdminAiUsageAccountSchema = z.object({
    accountId: z.string(),
    accountName: z.string(),
    planId: z.string(),
    llmWeightedTokensUsed: z.number(),
    llmWeightedTokensLimit: z.number(),
    sttSecondsUsed: z.number(),
    sttSecondsLimit: z.number(),
    periodStart: z.string(),
    periodEnd: z.string(),
});
export const SuperAdminAiUsageQuerySchema = z.object({
    offset: z.coerce.number().min(0).prefault(0),
    limit: z.coerce.number().min(1).max(100).prefault(50),
});
export const SuperAdminAiUsageResponseSchema = z.object({
    accounts: z.array(SuperAdminAiUsageAccountSchema),
    total: z.number(),
    hasMore: z.boolean(),
});
